import {
  Breadcrumbs,
  Link as MuiLink,
  SxProps,
  Theme,
  Typography,
  TypographyVariant,
} from "@mui/material";
import { Link, To } from "react-router-dom";

export interface BreadcrumbItem {
  title: string | React.ReactElement;
  to: To;
  icon?: React.ReactElement;
}

interface Props {
  breadcrumbs: BreadcrumbItem[];
  breadcrumbsSize?: "small" | "medium";
}

export function PageBreadcrumbLink({ link }: { link: BreadcrumbItem }) {
  return (
    <Breadcrumbs separator="›">
      <MuiLink component={Link} to={link.to}>
        <Typography variant="caption">
          {link.icon && (
            <span style={{ verticalAlign: "middle", marginRight: "4px" }}>
              {link.icon}
            </span>
          )}
          <span>{link.title}</span>
        </Typography>
      </MuiLink>
    </Breadcrumbs>
  );
}

export function PageBreadcrumbs({
  breadcrumbs,
  breadcrumbsSize = "small",
}: Props) {
  if (breadcrumbs.length < 1) return null;

  return (
    <Breadcrumbs separator="›" sx={containerStyle[breadcrumbsSize]}>
      {breadcrumbs.map((breadcrumb, index, array) =>
        breadcrumb.to === array[array.length - 1].to ? (
          <Typography
            key={index}
            variant={typographyVariant[breadcrumbsSize]}
            color="primary"
            style={{ fontWeight: 500 }}
          >
            {breadcrumb.title}
          </Typography>
        ) : (
          <MuiLink key={index} component={Link} to={breadcrumb.to}>
            <Typography variant={typographyVariant[breadcrumbsSize]}>
              {breadcrumb.icon && (
                <span style={{ verticalAlign: "middle", marginRight: "4px" }}>
                  {breadcrumb.icon}
                </span>
              )}
              <span>{breadcrumb.title}</span>
            </Typography>
          </MuiLink>
        )
      )}
    </Breadcrumbs>
  );
}

const typographyVariant: Record<string, TypographyVariant> = {
  small: "caption",
  medium: "body2",
};

const containerStyle: Record<string, SxProps<Theme> | undefined> = {
  small: {},
  medium: { py: 1.5 },
};
